import script from "./ArgonCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonCalendar.vue?vue&type=script&setup=true&lang=js"

import "./ArgonCalendar.vue?vue&type=style&index=0&id=86068248&scoped=true&lang=css"
import "./ArgonCalendar.vue?vue&type=style&index=1&id=86068248&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86068248"]])

export default __exports__